export default "/images/cmmc__protect_icon.png";